<template>
                    <div class="mypage-main-inner" v-if="myQnaList.length">
                      <p class="qna-info-txt">* 문의등록/수정은 1:1문의 게시판을 이용하여주시기 바랍니다.</p>
                      <!-- qna start { -->
                      <div class="qna">
                        <div
                          v-for="(item, index) in myQnaList"
                          :key = index           
                        >
                          <div
                            class="qna-list-box"
                            v-if="item.REPLY_OK === 'Y'"
                            :class="{'active' : item.isActive}"
                          >
                            <div class="qna-title" @click="item.isActive = !item.isActive">
                                <span class="btn btn-sm btn-outline-gray status success">답변완료</span>
                                <p class="txt text-truncate">{{ item.SUBJECT }}</p>
                                <span class="chevron"><i></i></span>
                            </div>
                            <div class="qna-area">
                                <div class="qna-q">
                                    <p class="txt">{{ item.SUBJECT }}</p>
                                    <div class="question">
                                        <div v-html="item.CONTENTS"></div>
                                    </div>
                                </div>
                                <div class="qna-a">
                                  <strong class="btn btn-sm btn-danger">답변</strong>
                                  <div class="answer">
                                    <div v-html="item.REPLY"></div>
                                  </div>
                              </div>
                            </div>
                          </div>

                          <div 
                            v-else
                            class="qna-list-box"
                            :class="{'active' : item.isActive}"
                          >
                            <div class="qna-title" @click="item.isActive = !item.isActive">
                              <span class="btn btn-sm btn-outline-gray status ready">답변대기</span>
                                <p class="txt text-truncate">{{ item.SUBJECT }}</p>
                                <span class="chevron"><i></i></span>
                            </div>
                            <div class="qna-btn-box">
                              <!-- <router-link :to="{ name:'QnaWrite', params:{ id: item.IDX }}">수정</router-link> -->
                              <button type="button" class="btn btn-sm btn-danger" @click="onDelete(item.IDX)">삭제</button>
                            </div>
                            <div class="qna-area">
                                <div class="qna-q">
                                    <p class="txt">{{ item.SUBJECT }}</p>
                                    <div class="question">
                                        <div v-html="item.CONTENTS"></div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div v-else class="mypage-main-null">등록된 문의가 없습니다.</div>
                      
                    <!-- 페이징 start-->
                    <div class="paging-area" v-if="myQnaList.length">
                      <v-pagination                  
                        v-model="currentPage"
                        :pages= numberOfPages
                        :rangeSize="1"            
                        @update:modelValue="updateHandler(currentPage)"
                      />
                    </div>
                    <!-- //페이징 end -->  

</template>

<script>
import { getCurrentInstance, ref, computed, watch } from 'vue';
import {useApicall} from '@/composables/commonFn';
import VPagination from "@hennge/vue3-pagination";
import '@/assets/css/vue3-pagination.css';

export default {
  props: {
    itemType: {
      type:String,
      required: true,
    },
  },  
  components: {
    VPagination,
  },

  setup(props) {
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    const { apiCall_gt } = useApicall();
    const limit = ref(10);
    const offset = ref(0);
    const currentPage = ref(1);     
    const numberOfData = ref(0);
    const numberOfPages = computed(()=>{
      return Math.ceil(numberOfData.value/limit.value)
    });
    
    const myQnaList = ref([]);
    const propsItemType = computed(()=>props.itemType)

    const updateHandler = (e) => {
      getMyCommentList(e);
    }

    const getMyCommentList = async(page = currentPage.value) => {
      currentPage.value = page;
      var offset = (currentPage.value -1) * limit.value;
      var getUrl = `board/counselinglist?limit=${limit.value}&offset=${offset}`

      var qnaDataList = await apiCall_gt(getUrl);

      try {
        if(qnaDataList.dataList == null) qnaDataList.dataList = [];
        myQnaList.value = qnaDataList.dataList;
        numberOfData.value = qnaDataList.dataCount;
      } catch(error) {
        myQnaList.value = [];
        numberOfData.value  = 0;
      }
    }

    const deletCall = async (id) =>{
      var res  =  await apiCall_gt(`board/counselingdelete/${id}`, 'DEL');
      if(res) { 
       // console.log('deletCall', id);
        emitter.emit('EVENT_ALERT',{title:"알림", body:"1:1 문의글이 삭제되었습니다."});
      }
    }
    
    const onDelete = (id) =>{
      deletCall(id);
      updateHandler(1);
    }

    watch(propsItemType, ()=> {      
      if(propsItemType.value == 'qna') {
        updateHandler(1);
      } else {
        return false;
      }
    })

    return{
      limit,
      offset,
      myQnaList,
      numberOfPages,
      currentPage,
      updateHandler,
      onDelete,
    }
  }
}
</script>

<style>

</style>